const BASE = process.env.REACT_APP_API_URL || 'https://microled.com.ar/api';
const SESSION_KEY = 'ml_admin_session';

async function authReq(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  });
  return res.json();
}

// ── Password / Setup ──────────────────────────────────────────────────────────

export const isPasswordConfigured = async () => {
  try {
    const data = await authReq('GET', '/auth/status');
    return !!data.configured;
  } catch { return false; }
};

export const setupPassword = async (password) => {
  if (password.length < 8) return { ok: false, error: 'La contraseña debe tener al menos 8 caracteres.' };
  try {
    const data = await authReq('POST', '/auth/setup', { password });
    if (data.ok) {
      localStorage.setItem(SESSION_KEY, JSON.stringify({ token: data.token, expiresAt: data.expiresAt }));
      return { ok: true };
    }
    return { ok: false, error: data.error || 'Error al configurar.' };
  } catch { return { ok: false, error: 'Error de conexión.' }; }
};

// ── Login / Logout ────────────────────────────────────────────────────────────

export const login = async (password) => {
  try {
    const data = await authReq('POST', '/auth/login', { password });
    if (data.ok) {
      localStorage.setItem(SESSION_KEY, JSON.stringify({ token: data.token, expiresAt: data.expiresAt }));
      return { ok: true };
    }
    return { ok: false, error: data.error || 'Contraseña incorrecta.' };
  } catch { return { ok: false, error: 'Error de conexión.' }; }
};

export const logout = () => {
  try {
    const item = localStorage.getItem(SESSION_KEY);
    if (item) {
      const { token } = JSON.parse(item);
      authReq('POST', '/auth/logout', { token }).catch(() => {});
    }
  } catch {}
  localStorage.removeItem(SESSION_KEY);
  // limpiar claves del sistema anterior
  localStorage.removeItem('ml_admin_auth');
  localStorage.removeItem('ml_admin_hash');
  localStorage.removeItem('ml_login_attempts');
};

// ── Session check (sync — solo verifica expiración local del token) ────────────

export const isAuthenticated = () => {
  try {
    const item = localStorage.getItem(SESSION_KEY);
    if (!item) return false;
    const { expiresAt } = JSON.parse(item);
    return new Date(expiresAt) > new Date();
  } catch { return false; }
};

// ── Stubs — rate limiting ahora es server-side ────────────────────────────────

export const isLockedOut = () => false;
export const lockoutRemainingSeconds = () => 0;
